import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "draggable"]

export interface propsComponent {
  isPreview: boolean;
}
import { useAttrs, computed, withDefaults } from "vue";

import { defineComponent, ref } from "vue";
import Rating from "primevue/rating";
const __default__ = defineComponent({
  name: "VZRating",
  inheritAttrs: false,
  components: {
    Rating,
  },
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    isPreview: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { isPreview: boolean }


const attrs = useAttrs();
const ratingValue = ref(0);
const style = computed(() => {
  return !props.isPreview ? "pointer-events: none" : "";
});
const restAttr = computed(() => {
  const { id, draggable, ...rest } = attrs;
  if (rest.style && rest.style.defaultBorder === "true !important") {
    rest.style.borderColor = "";
    rest.style.borderWidth = "";
    rest.style.borderStyle = "";
    rest.style.padding = "";
    rest.style.margin = "";
    rest.borderColor = "";
    rest.borderWidth = "";
    rest.borderStyle = "";
    rest.padding = "";
    rest.margin = "";
  }
  return rest;
});
const isDraggable = computed(() => {
  return attrs?.draggable ?? false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "VZ_TABLE_BUTTON",
    id: _unref(attrs).id,
    draggable: _unref(isDraggable)
  }, [
    _createVNode(_unref(Rating), _mergeProps({
      modelValue: ratingValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ratingValue).value = $event)),
      stars: 7,
      cancel: true
    }, _unref(restAttr), { style: _unref(style) }), null, 16, ["modelValue", "style"])
  ], 8, _hoisted_1))
}
}

})